import React from "react";
import { motion } from "framer-motion";

export const revealVariants = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export const Reveal = ({ children, className = "", delay = 0, as: Tag = "div", ...rest }) => {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={{
        hidden: revealVariants.hidden,
        show: { ...revealVariants.show, transition: { ...revealVariants.show.transition, delay } },
      }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
